export const updateSessionUserFlagValue = async (
  flagKey: string,
  flagValue: boolean,
) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_BASE_PATH}/api/launch-darkly/update-user-flag`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
      body: JSON.stringify({
        flagKey,
        flagValue,
      }),
    },
  );

  if (!response.ok) {
    throw new Error('Failed to update user flag');
  }

  return response.json();
};
